<template>
  <div
    :class="{
      [`bg-${type}`]: type,
      rounded: rounded,
    }"
    class="so-banner__container"
    role="alert"
    aria-live="polite"
    data-testid="so-banner"
  >
    <slot />
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"

  type BannerTypes = "success" | "info" | "warning" | "error"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      type: {
        type: String as PropType<BannerTypes>,
        default: "warning",
      },
      rounded: {
        type: Boolean,
        default: false,
      },
    },
  })
</script>

<style>
  .so-banner__container {
    width: 100%;
    padding: 8px;
    text-align: center;
  }
  .so-banner__container a {
    color: inherit;
  }
</style>
